import { resolveWithBody } from "./Utils/utils";
import { usePromisedRequest as promiseRequest } from "../Common/request";
import { DisplayProviderType } from "./pricing";

export const PROVIDER_STRIPE = "STRIPE";
export const PROVIDER_PRZELEWY24 = "PRZELEWY24";
export const PROVIDER_ASAAS = "ASAAS";

export const ProviderEnum = {
    Stripe: PROVIDER_STRIPE,
    Przelewy24: PROVIDER_PRZELEWY24,
    Asaas: PROVIDER_ASAAS,
};
export type ProviderEnumType = (typeof ProviderEnum)[keyof typeof ProviderEnum];

export type ExistingPaymentGatewayConfig = {
    id: string;
    name: string;
    provider: DisplayProviderType;
};

export type CheckConnectionResponse = {
    success: boolean;
    apiResponse: {
        body: string;
        statusCode: number;
    } | null;
};

export type CheckConnectionRequest<T> = {
    provider: ProviderEnumType;
    providerConfiguration: T;
};

export type AsaasProviderConfiguration = {
    apiKey: string;
};
export type StripeProviderConfiguration = {
    secretKey: string;
};
export type Przelewy24ProviderConfiguration = {
    accountId: string;
    apiKey: string;
    crcKey: string;
};

export default {
    getConfigListingForUser(userId: number): Promise<Array<ExistingPaymentGatewayConfig>> {
        return promiseRequest<Array<ExistingPaymentGatewayConfig>>({
            url: `/api/users/${userId}/payment-gateway-configs`,
            method: "GET",
            json: true,
        }).then(resolveWithBody());
    },
    createConfig<T>(userId: number, name: string, provider: ProviderEnumType, providerData: T): Promise<ExistingPaymentGatewayConfig> {
        return promiseRequest<ExistingPaymentGatewayConfig>({
            url: `/api/users/${userId}/payment-gateway-configs`,
            json: {
                name: name,
                provider: provider,
                providerConfiguration: providerData,
            },
            method: "post",
        }).then(resolveWithBody());
    },
    checkConnection<T>(userId: number, data: CheckConnectionRequest<T>): Promise<CheckConnectionResponse> {
        return promiseRequest<CheckConnectionResponse>({
            url: `/api/users/${userId}/payment-gateway-configs/check-connection`,
            method: "post",
            json: {
                provider: data.provider,
                providerConfiguration: data.providerConfiguration,
            },
        }).then(resolveWithBody());
    },
};
